import { useNavigate } from 'react-router-dom'

export const TOKEN_TYPE_URL = '/utils/token'

export const useGoToTokenType = () => {
  const navigate = useNavigate()

  return {
    go: () => {
      navigate(TOKEN_TYPE_URL)
    }
  }
}
